// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Mingguan_table_wrapper__GWcjO","status_header":"Mingguan_status_header__TLFKc","status":"Mingguan_status__xhiuy","cell":"Mingguan_cell__LV076"};